import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/components/Index'
import Signup from '@/components/Signup'
import Login from '@/components/Login'
import AddPlace from '@/components/AddPlace'
import EdiPlace from '@/components/EditPlace'
import EditPlace from '@/components/EditPlace'
import Upload from '@/components/Upload'
import Place from '@/components/Place'
import Map from '@/components/Map'
import firebase from "firebase"


Vue.use(Router)

const router = new Router({
  mode:"history",
  routes: [
    {
      path: '/',
      name: 'Index',
      component: Index,
      
    },
    {
      path: '/index',
      name: 'Index',
      component: Index,
      
    },
    {
      path: '/signup',
      name: 'Signup',
      component: Signup
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/add-place',
      name: 'AddPlace',
      component: AddPlace,
      meta:{
        requiresAuth:true
      }
    },
   
    {
      path: '/editplace/:place_slug',
      name: 'EditPlace',
      component: EditPlace,
      meta:{
        requiresAuth:true
      }
    },
    {
      path: '/upload',
      name: 'Upload',
      component: Upload,
      meta:{requiresAuth: true}
    },
    {
      path: '/place/:place_id',
      name: 'Place',
      component: Place,
      meta:{
        requiresAuth:true
      }
    },
    {
      path: '/map/:id',
      name: 'Map',
      component: Map
    }
    
    
  ]
})
router.beforeEach((to, from, next) => {
  if(to.matched.some(rec => rec.meta.requiresAuth)){
    let user = firebase.auth().currentUser
    if(user){
      next()
    }else{
      next({name:"Login"})
    }
  }else{
    next()
  }

})
export default router


// WEBPACK FOOTER //
// ./src/router/index.js